import React, { useState, useEffect } from 'react';
import { useTrail } from 'react-spring';
import { useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet';

import NetworkManager from '../classes/NetworkManager';

import { Container, HeadingContainer, Heading } from '../components/styledComponents';
import Author, { AuthorSkeleton } from '../components/author';
import Illustration from '../components/illustration';

const Followers = () => {
    const { authorId } = useParams();
    const [followers, setFollowers] = useState([]);
    const [followersRequested, setFollowersRequested] = useState(false);

    const config = { mass: 1, tension: 120, friction: 14 };
    const followersTrail = useTrail(followers.length, {
        config,
        from: { opacity: 0, y: '100%' },
        to: { opacity: 1, y: '0%' }
    });

    useEffect(() => {
        const nm = new NetworkManager();
        if (followers.length === 0 && !followersRequested) {
            nm.getFollowers(authorId).then((followersList) => {
                setFollowersRequested(true);
                setFollowers(followersList.filter(f => f !== null));
            });
        }
    });

    return (
        <Container>
            <Helmet><title>Followers</title></Helmet>
            <HeadingContainer>
                <Heading>Followers</Heading>
            </HeadingContainer>
            {!followersRequested && Array(3).fill().map((i, k) => <AuthorSkeleton key={k} />)}
            {followers.length > 0 && followersRequested && followersTrail.map(({ ...styleProps }, i) => (
                <React.Fragment key={followers[i].id}>
                    <Author {...followers[i]} {...styleProps} />
                </React.Fragment>
            ))}
            {followers.length === 0 && followersRequested && <Illustration illustration="editor" title="No followers" text="No one has followed you yet." />}
        </Container>
    );
};

export default Followers;
